import React, { useState, useEffect } from "react";
import { Nav, Accordion } from "react-bootstrap";
import Circle from "../../components/Circle";
import AIProcessingWidget from "./aiProcessingWidget";
import "./webReportEdit.css";

const EditDrawer = ({ sections, activeSection, onNavigate }) => {
  const [sectionActiveKeys, setSectionActiveKeys] = useState([]);

  const toggleAccordion = (key) => {
    setSectionActiveKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  // Expand every section accordion by default.
  useEffect(() => {
    if (sections && sections.length > 0) {
      setSectionActiveKeys((prev) => {
        const allKeys = sections.map((s) => `accordion-${s.name}`);
        const missing = allKeys.filter((k) => !prev.includes(k));
        return missing.length ? [...prev, ...missing] : prev;
      });
    }
  }, [sections]);

  const sectionAccordionItems = (sections || []).map((section, sectionIdx) => {
    const hasSubsections =
      section.subsections && section.subsections.length > 0;
    const sectionId = `section-${section.name?.toLowerCase().replace(/\s+/g, "-")}`;
    const isSectionActive = activeSection === sectionId;

    return (
      <Accordion.Item
        eventKey={`accordion-${section.name}`}
        key={section.id || `${section.name}-${sectionIdx}`}
      >
        <Accordion.Header
          className={`section-accordion-header ${isSectionActive ? "active" : ""}`}
          onClick={() => toggleAccordion(`accordion-${section.name}`)}
        >
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>{section.name}</div>
          </div>
        </Accordion.Header>
        {hasSubsections && (
          <Accordion.Body>
            {section.subsections.map((subsection, subIdx) => {
              const subsectionId = `subsection-${subsection.name?.toLowerCase().replace(/\s+/g, "-")}`;
              const isSubsectionActive = activeSection === subsectionId;
              const issueCount =
                (subsection?.issues?.length || 0) +
                (subsection?.infos?.length || 0) +
                (subsection?.limits?.length || 0);

              return (
                <div
                  key={subsection.id || `${subsection.name}-${subIdx}`}
                  className={`drawer-nav-item subsection-nav-item ${isSubsectionActive ? "active" : ""}`}
                >
                  <Nav.Link
                    href={`#${subsectionId}`}
                    onClick={(e) => {
                      e.preventDefault();
                      onNavigate(subsectionId);
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <span>{subsection.name}</span>
                      {issueCount > 0 && (
                        <Circle type="general" text={issueCount} />
                      )}
                    </div>
                  </Nav.Link>
                </div>
              );
            })}
          </Accordion.Body>
        )}
      </Accordion.Item>
    );
  });

  return (
    <div className="edit-drawer">
      <div className="edit-drawer-content">
        <div
          id="nav-item-inspection-overview"
          className={`drawer-nav-item ${activeSection === "inspection-overview" ? "active" : ""}`}
        >
          <Nav.Link
            href="#inspection-overview"
            onClick={(e) => {
              e.preventDefault();
              onNavigate("inspection-overview");
            }}
          >
            Inspection Overview
          </Nav.Link>
        </div>
        <hr className="edit-drawer-divider" />
        <Accordion
          className="section-accordion-container"
          activeKey={sectionActiveKeys}
          alwaysOpen
        >
          {sectionAccordionItems}
        </Accordion>
      </div>
      <AIProcessingWidget onViewItem={onNavigate} />
    </div>
  );
};

export default EditDrawer;
